/********************************************************
* Data Store
*
* Used to save persistent data
* 
* !! No DOM touching allowed in this module dude !!
********************************************************/


// requirements




/**********************************************
 Variable Declarations
**********************************************/

// define module object to be exported
var m = {};
var dataModel = {};
var tempStore = {};


// cookie related variables
var cookieName = "closet";
var cookieExpireDays = 1;

// capabilities check variables
var lsAvailable = (window.localStorage) ? true : false;
var cAvailable = navigator.cookieEnabled;




/**********************************************
 Private Functions
**********************************************/

// Method used internally to clear out local data model
clear_data_model = function() { 
    if (typeof dataModel !== 'undefined') {
        dataModel = {}; 
        return true;
    }
    else return false;
}


// Method used internally to update or set value in model
set_data_model = function(key, value) { 
    if (typeof dataModel !== 'undefined') {
        dataModel[key] = value; 
        return true;
    }
    else return false;
}


// Method used internally to retrieve a value from local data model
get_data_model = function(key) { 
    if ( dataModel.hasOwnProperty( key) ) return dataModel[key]; 
    else {
        console.info('   * Closet Module - Property requested does not exist.');
        return null;
    }
}


// Method used to remove an item from the local data model
remove_data_model = function(key) { 
    if ( dataModel.hasOwnProperty( key ) ) {
        delete dataModel[key]; 
        return true;
    }
    else {
        console.info('   * Closet Module - Property you are attempting to delete does not exist.');
        return false;
    }
}


// Check if string is JSON format or not
is_json_string = function(str) {
    try {
        JSON.parse(str);
    }
    catch (e) {
        return false;
    }
    return true;
}


// Set values for cookie, note that this always overrides
cookie_set = function (value) {
    if (cookieExpireDays) {
        var date = new Date();
        date.setTime(date.getTime() + (cookieExpireDays * 24 * 60 * 60 * 1000));
        var expires = "; expires=" + date.toGMTString();
    }
    else var expires = "";
    document.cookie = cookieName + "=" + JSON.stringify(value) + expires + "; path=/";
}


// retrieve cookie values based on cookie name
cookie_get = function(){
    var nameEQ = cookieName + "=",
        ca = document.cookie.split(';');

    for(var i=0;i < ca.length;i++) {
      var c = ca[i];
      while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) {
            var value = c.substring(nameEQ.length,c.length);
            if ((value.length > 0) && (value != 'undefined'))  {
                return  JSON.parse(c.substring(nameEQ.length,c.length));
            }
            else return {};
        }
    }
    return {};
}







 /**********************************************
 Public Functions
**********************************************/

// Request what mode closet module is operating in
m.mode = function() {
    if (lsAvailable) return "localStorage";
    else if (cAvailable) return "cookies";
    else return "variable";
}


// Set & Get functions for cookie name
m.set_cookie_name = function(name) { 
    cookieName = name; 
    if ((!lsAvailable) && (cAvailable)) dataModel = cookie_get( cookieName );
}
m.get_cookie_name = function() { return cookieName; }


// Set & Get functions for cookie expire days
m.set_cookie_expires_days = function(days) { cookieExpireDays = days; }
m.get_cookie_expires_days = function() { return cookieExpireDays; }


// method to clear all items in storage
m.clear = function() {
    if ( clear_data_model() ) {
        if (lsAvailable) localStorage.clear();
        else if (cAvailable) document.cookie = cookieName + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
        return true;
    }
    else {
        console.error('**** Closet Module - Trouble clearing data, not a good sign.');
        return false;
    }
}


// method used to set a key/value pair
m.set = function(key, value) {
    set_data_model(key, value);

    if (lsAvailable) {
        localStorage[key] = (typeof value == "object") ? JSON.stringify(value) : value;
    }
    else if (cAvailable) cookie_set( dataModel )
}


// method used to retrieve inidividual key value if key provided, else you get the whole thing
m.get = function(key) {
    if (typeof key !== "undefined") return get_data_model(key);
    else {
        return dataModel;
    }
}


// method to remove key value from closet storage, key must be provided, else use clear
m.remove = function(key) {
    if (typeof key !== "undefined") {
        remove_data_model(key);

        if (lsAvailable) localStorage.removeItem(key);
        else if (cAvailable) cookie_set( dataModel );
    }
    else {
        console.error('**** Closet Module - key value must be provided to remove method.');
        return false;
    }
}


// Some quick methods for cross module data storage that doesn't need to be persistent
m.ds_set = function(key, value) {
    tempStore[key] = value;
}
m.ds_get = function(key) {
    if (tempStore[key]) return tempStore[key];
    else return null;
}
m.ds_remove = function(key) {
    delete tempStore[key];
}


/**********************************************
 Initial Run
**********************************************/

// if neither storage method available log error and use window level variable (non persistent)
if ((!lsAvailable) && (!cAvailable)) {
    console.error('**** Closet Module - No persistent storage available for closet module, using variable instead.');
}
else {
    // get initial data from persistent storage
    if (lsAvailable) {
        for (var i = 0; i < localStorage.length; i++){
            var key = localStorage.key(i);
            if ( is_json_string(localStorage[key]) ) {
                dataModel[key] = JSON.parse( localStorage[key] );
            }
            else dataModel[key] = localStorage[key];
        }
    }
    else if (cAvailable) {
        dataModel = cookie_get( cookieName );
    }
}



// export module
module.exports = m;